import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import "./Fonts.css";

const useStyles = makeStyles((theme) => ({
  mainFeaturedPost: {
    position: "relative",
    backgroundColor: theme.palette.grey[800],
    color: theme.palette.common.white,
    marginBottom: theme.spacing(4),
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
  },
  overlay: {
    position: "absolute",
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    backgroundColor: "rgba(0,0,0,.3)",
  },
  mainFeaturedPostContent: {
    position: "relative",
    padding: theme.spacing(3),
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(6),
      paddingRight: 0,
    },
    width: "inherit",
    display: "flex",
    flexDirection: "column",
    justifyItems: "center",
  },
  postTitle: {
    color: "#ED6F63",
    fontFamily: "MyFont",
  },
  postDesc: {
    fontFamily: "MyFont",
  },
}));

export default function MainFeaturedPost(props) {
  const classes = useStyles();
  const { post } = props;

  return (
    <Paper className={classes.mainFeaturedPost}>
      {/* Increase the priority of the hero background image */}
      <div className={classes.overlay} />
      <Grid container>
        <Grid item md={8}>
          <div className={classes.mainFeaturedPostContent}>
            <Typography
              component="h1"
              variant="h3"
              color="inherit"
              gutterBottom
              className={classes.postTitle}
            >
              {post.title}
            </Typography>
            <div />
            <Typography
              variant="h6"
              color="inherit"
              paragraph
              className={classes.postDesc}
            >
              {`화재 인명피해를 줄이는 핵심은 조기 탐지 입니다.`}
              <div style={{ height: "10px" }} />
              {`기존의 온도 및 연기를 통한 감지 시스템에서`}
              <div style={{ height: "10px" }} />
              {`1단계 진화한 영상 감지 시스템으로 여러분의 소중한 생명을 지키겠습니다.`}
            </Typography>
            <Link variant="subtitle1" href="#">
              {post.linkText}
            </Link>
          </div>
        </Grid>
      </Grid>
    </Paper>
  );
}

MainFeaturedPost.propTypes = {
  post: PropTypes.object,
};
